import React, { Component } from "react"

import NotificationDeleteModal from "./NotificationDeleteModal"
import NotificationNoEditModal from "./NotificationNoEditModal"

import SpinnerImage from "../../../common/SpinnerImage"
import WidgetHeaderButton from "../../../common/WidgetHeaderButton"

class NotificationViewFormActionButtonsWidget extends Component {
    state = {
        isDeleteModalOpen: false,
        isNoEditModalOpen: false,
    }

    handleDelete = (activeId) => () => {
        this.props.onDelete(activeId)
        this.setState({ isDeleteModalOpen: false })
    }

    toggleDeleteModal = () => {
        this.setState({ isDeleteModalOpen: !this.state.isDeleteModalOpen })
    }

    toggleNoEditModal = () => {
        this.setState({ isNoEditModalOpen: !this.state.isNoEditModalOpen })
    }

    handleEdit = () => {
        if (!this.props.notYetSent) {
            this.toggleNoEditModal()
        } else {
            this.props.onEdit()
        }
    }

    render() {
        const {
            canEdit,
            canDelete,
            children,
            activeId,
            isDeleting,
            title,
            isInSendingWindow,
            afterSendingWindow,
        } = this.props

        return (
            <div className="widget small-widget-padding">
                <div className="widget-header">
                    <div className="save-buttons pull-right">
                        {isDeleting && <SpinnerImage />}
                        {children}
                        <span>
                            <WidgetHeaderButton
                                isSecondary={true}
                                disabled={!canDelete}
                                onClick={this.toggleDeleteModal}
                            >
                                Delete
                            </WidgetHeaderButton>
                            <NotificationDeleteModal
                                isOpen={this.state.isDeleteModalOpen}
                                title={title}
                                isInSendingWindow={isInSendingWindow}
                                afterSendingWindow={afterSendingWindow}
                                onDelete={this.handleDelete(activeId)}
                                toggle={this.toggleDeleteModal}
                            />
                        </span>
                        <WidgetHeaderButton
                            disabled={!canEdit}
                            onClick={this.handleEdit}
                        >
                            Edit
                        </WidgetHeaderButton>
                        <NotificationNoEditModal
                            isOpen={this.state.isNoEditModalOpen}
                            title={title}
                            isInSendingWindow={isInSendingWindow}
                            toggle={this.toggleNoEditModal}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
export default NotificationViewFormActionButtonsWidget
